import React, { FunctionComponent } from 'react';
import { Label, Popup } from 'semantic-ui-react';
import { Review } from '../types/review.type';

type ReviewSourceLabelProps = {
  source: Review['source'];
  size?: 'mini' | 'small';
};

export const ReviewSourceLabel: FunctionComponent<ReviewSourceLabelProps> = ({
  source,
  size = 'small',
}) => {
  if (source === 'BILIK') {
    return null;
  }

  return (
    <Popup
      content={source}
      trigger={
        <Label color="blue" size={size}>
          Externe
        </Label>
      }
    />
  );
};
